import { styled } from "@mui/material"

export const PopoverContainer = styled('div')({
  position: 'relative'
})